/**
 * NỘI DUNG TRANG SKILL VIDEO KỂ CHUYỆN QUẢNG CÁO (/tools/video-ke-chuyen-quang-cao)
 *
 * Dùng chung trang VideoBatchToolPage — cấu trúc trường giống qaVideoSkillContent.js.
 *
 * File trên máy chủ: web/back-end/storage/tools/Bo-skill-video-ke-chuyen-quang-cao.zip (DESKTOP_TOOLS['story-video-skill'],
 * pharmacy-tool.controller.js) — MỘT file gồm storytelling-quangcao-v11.zip (khách giữ nguyên, tải lên ChatGPT),
 * HUONGDAN-video-ke-chuyen-quang-cao.pdf (ảnh đã nén) và DOC-TRUOC.txt. Bản gốc ở docs/goc-huong-dan-skill (không lên máy chủ).
 * Video mẫu là YouTube Shorts (sampleVideos), máy chủ không lưu video.
 * Tải bộ skill cần mua gói TOOL_VIDEO_KE_CHUYEN (50.000đ / 12 tháng, sheet "Hệ thống tool" dòng 8 "Skill quảng cáo kể chuyện").
 * Các bước bên dưới tóm tắt từ hướng dẫn PDF (B1–B14) và SKILL.md bản v11 — đổi bản skill thì đối chiếu lại.
 */
export const STORY_VIDEO_SKILL_TOOL = {
  published: true,

  slug: 'video-ke-chuyen-quang-cao',
  contentFile: 'storyVideoSkillContent.js',
  name: 'Skill Video Kể Chuyện Quảng Cáo',
  kindLabel: 'SKILL CHATGPT + GOOGLE FLOW',
  tagline: 'Gửi ảnh sản phẩm và nhân vật, ChatGPT viết 3 câu chuyện quảng cáo có lời thoại; Google Flow dựng thành video kể chuyện bán hàng',
  intro:
    'Cài skill vào ChatGPT một lần. Mỗi video: gửi ảnh sản phẩm (phông trắng, rõ chữ trên hộp) và ảnh nhân vật, ghi yêu cầu. ' +
    'Skill tự tìm hiểu sản phẩm và giới hạn quảng cáo, đưa 3 câu chuyện có sẵn lời thoại; chọn 1 câu chuyện là có lời nhắc cho từng cảnh 10 giây. ' +
    'Bạn tạo từng cảnh trên Google Flow, gửi lại cho ChatGPT để nối thành video quảng cáo hoàn chỉnh khung dọc 9:16.',
  version: 'v11',
  fileSize: '',
  updatedAt: '17/10/2026',
  platforms: ['Máy tính có trình duyệt', 'ChatGPT', 'Google Flow'],
  image: '/images/tools/skill-video-ke-chuyen.jpg',
  heroBanner: '/images/tools/skill-video-ke-chuyen.jpg',

  downloadLabel: 'Tải bộ skill (.zip)',
  loginLabel: 'Đăng nhập để mua / tải skill',

  // YouTube Shorts (chỉ điền ID): youtube.com/shorts/UteYyCPb6vI, youtube.com/shorts/WiO4QQQRdlI
  sampleVideos: [
    { youtubeId: 'UteYyCPb6vI', title: 'Video mẫu 1' },
    { youtubeId: 'WiO4QQQRdlI', title: 'Video mẫu 2' },
  ],
  sampleVideosNote: 'Hai video quảng cáo kể chuyện làm ra từ skill, các cảnh 10 giây nối liền.',

  highlights: [
    { value: '3 câu chuyện', label: 'có sẵn lời thoại cho mỗi sản phẩm, chọn 1 là xong' },
    { value: '10 giây', label: 'mỗi cảnh, lời thoại canh sẵn; video 40 giây có 4 cảnh' },
    { value: 'Đúng hộp', label: 'sản phẩm hiện đúng chữ trên nhãn, nét, phía sau mờ' },
  ],

  features: [
    { title: 'Tự tìm hiểu sản phẩm', desc: 'Đọc nhãn trên ảnh, tra thông tin sản phẩm và giới hạn quảng cáo, không cần bạn gửi tài liệu.' },
    { title: '3 câu chuyện cảm xúc', desc: 'Mỗi lần đưa 3 câu chuyện có lời thoại tiếng Việt, lồng sản phẩm khéo léo; muốn sửa lời thì ghi luôn khi chọn.' },
    { title: 'Giữ đúng nhân vật, đúng hộp', desc: 'Lời nhắc từng cảnh khóa khuôn mặt, trang phục và nhãn sản phẩm, kèm bảng cảnh nào cần ảnh nào.' },
    { title: 'Nối thành video hoàn chỉnh', desc: 'Gửi các cảnh lại cho ChatGPT, skill nối đúng thứ tự cảnh thành một video, không chèn thêm chữ.' },
  ],

  audience: [
    'Chủ nhà thuốc, nhân viên marketing làm video quảng cáo sản phẩm',
    'Nhà thuốc muốn có video kể chuyện bán hàng mà không cần quay dựng',
  ],

  requirements: [
    { label: 'ChatGPT', value: 'Tài khoản ChatGPT có mục Plugin → Kỹ năng để tải skill lên' },
    { label: 'Google Flow', value: 'Tài khoản Google Flow (flow.google.com) đủ tín dụng, dùng model Omni 1.1 Flash' },
    { label: 'Ảnh nhân vật', value: 'Phông trắng, mỗi ảnh một người, thẳng mặt, thấy rõ từ ngực trở lên' },
    { label: 'Ảnh sản phẩm', value: 'Phông trắng, chụp thẳng mặt trước hộp, chữ trên hộp đọc rõ, không lóa' },
  ],

  installTitle: 'Hướng dẫn dùng skill',
  installSubtitle: 'Tóm tắt các bước trong file hướng dẫn PDF (có ảnh chụp từng bước). Cài skill chỉ làm một lần.',
  installTabLabel: 'Các bước',

  installSteps: [
    {
      title: 'Tải bộ skill',
      desc: 'Bấm "Tải bộ skill (.zip)" rồi giải nén bộ này. Bên trong có file skill storytelling-quangcao-v11.zip và file HUONGDAN-video-ke-chuyen-quang-cao.pdf.',
      tip: 'Chỉ giải nén bộ tải về. File skill .zip bên trong giữ nguyên, không giải nén.',
    },
    {
      title: 'Chuẩn bị ảnh',
      desc: 'Tạo một thư mục riêng cho mỗi video, bỏ ảnh nhân vật và ảnh sản phẩm vào, đặt tên ảnh theo vai, ví dụ: anh Thế, Người bố, sản phẩm Glucosamin.',
      tip: 'Ảnh mờ, nền lộn xộn hoặc chữ trên hộp bị lóa thì video sẽ sai mặt, sai chữ trên hộp.',
    },
    {
      title: 'Cài skill vào ChatGPT (một lần)',
      desc: 'Vào chatgpt.com → thanh bên trái bấm Plugin → Kỹ năng → Thêm → Tải lên từ máy tính → chọn file storytelling-quangcao-v11.zip → Mở. Skill hiện trong mục "Do tôi tạo" là xong.',
    },
    {
      title: 'Gọi skill, gửi ảnh và yêu cầu',
      desc: 'Bấm Đoạn chat mới → Công việc, kéo mức nỗ lực sang phải 2–3 nấc. Gõ dấu / và chọn STORYTELLING-QUANGCAO. Bấm + → Thêm ảnh & tệp để gửi đủ ảnh, rồi ghi yêu cầu, ví dụ: "Câu chuyện cảm động lồng ghép quảng cáo sản phẩm khéo léo. Ảnh anh Thế là người con, ảnh Người bố là bố. Video 40 giây, dọc."',
    },
    {
      title: 'Chọn câu chuyện',
      desc: 'Đọc 3 câu chuyện, gõ số câu chuyện thích nhất (1, 2 hoặc 3), muốn sửa lời thoại thì ghi luôn sau số. Chờ 1–3 phút để nhận lời nhắc từng cảnh và bảng "cảnh nào cần ảnh nào".',
    },
    {
      title: 'Tạo từng cảnh trên Google Flow',
      desc: 'Vào flow.google.com → Dự án mới → tải ảnh lên. Cài đặt một lần: Video, Thành phần, 9:16, Omni 1.1 Flash, 10 giây. Với từng cảnh: chép lời nhắc từ ChatGPT dán vào Flow, thêm đúng ảnh theo bảng, bấm tạo; chọn bản đẹp, tải về 720p và đặt tên canh1, canh2…',
      tip: 'Phải chọn Thành phần (không chọn Khung hình) và đúng 10 giây, vì lời thoại đã canh theo 10 giây.',
    },
    {
      title: 'Nối video hoàn chỉnh',
      desc: 'Quay lại đúng đoạn chat cũ, bấm + → Thêm ảnh & tệp, gửi lần lượt canh1, canh2… đúng thứ tự. Skill nối thành video hoàn chỉnh, bấm "Tải video hoàn chỉnh" để tải về.',
      tip: 'Khi đăng quảng cáo, thêm câu bắt buộc ChatGPT nhắc (ví dụ "Thực phẩm này không phải là thuốc và không có tác dụng thay thế thuốc chữa bệnh"), hiện rõ trên hình và đọc rõ.',
    },
  ],

  installStepsMac: [],

  youtubeVideoId: '',

  faqs: [
    {
      q: 'Skill giá bao nhiêu?',
      a: '50.000đ, dùng 12 tháng, tải bộ skill (skill + hướng dẫn PDF) về nhiều lần. Thanh toán bằng QR chuyển khoản, mở tải ngay sau khi chuyển khoản thành công. Phí dùng ChatGPT và tín dụng Google Flow tính riêng theo tài khoản của bạn.',
    },
    {
      q: 'Có cần giải nén file .zip không?',
      a: 'Giải nén bộ vừa tải về (Bo-skill-...zip) để lấy file skill và file hướng dẫn. File skill storytelling-quangcao-v11.zip bên trong thì giữ nguyên, tải lên ChatGPT nguyên file .zip.',
    },
    {
      q: 'Nhân vật trong video không giống ảnh?',
      a: 'Kiểm tra đã chọn "Thành phần" trong cài đặt Flow (không chọn Khung hình). Chụp lại ảnh nhân vật phông trắng, thẳng mặt, đủ sáng.',
    },
    {
      q: 'Chữ trên hộp sản phẩm bị sai?',
      a: 'Chụp lại ảnh sản phẩm rõ chữ, không lóa, rồi tạo lại riêng cảnh có sản phẩm.',
    },
    {
      q: 'Video có người lạ hoặc sai hộp?',
      a: 'Đưa đúng, đủ ảnh theo bảng "cảnh nào cần ảnh nào"; xóa ảnh của cảnh trước trước khi làm cảnh mới.',
    },
    {
      q: 'Hết tín dụng trong Flow?',
      a: 'Giảm số bản mỗi lần tạo xuống x1 trong cài đặt video của Flow.',
    },
    {
      q: 'Lỡ gửi video sai thứ tự?',
      a: 'Nhắn ChatGPT, ví dụ: "Video thứ 2 tôi gửi là cảnh 3, video thứ 3 là cảnh 2".',
    },
    {
      q: 'Nội dung quảng cáo có cần kiểm tra lại không?',
      a: 'Có. Xem lại video trước khi đăng, đặc biệt các thông tin về công dụng sản phẩm; cảnh nào ChatGPT báo lỗi thì tạo lại riêng cảnh đó trong Flow.',
    },
  ],

  support: {
    text: 'Cài skill hoặc làm video gặp khó khăn? Gọi hoặc nhắn Zalo đội hỗ trợ kèm ảnh chụp màn hình.',
    phone: '0812539539',
    phoneLabel: '0812.539.539',
  },

  ctaTitle: 'Sẵn sàng làm video quảng cáo kể chuyện?',
  ctaText: 'Tải bộ skill, cài vào ChatGPT trong vài phút và gửi ảnh sản phẩm đầu tiên.',
};
